import { DrinkVariant } from '@/config/drinkVariants';
import { useCart } from '@/context/CartContext';

interface CTASectionProps {
  currentVariant: DrinkVariant;
}

const CTASection = ({ currentVariant }: CTASectionProps) => {
  const { addItem } = useCart();

  const handleAddToCart = () => {
    addItem({
      id: `g-${currentVariant.id}`,
      name: currentVariant.name,
      subtitle: currentVariant.subtitle,
      brand: 'G Drink',
      productImage: currentVariant.productImage,
      price: currentVariant.price,
    });
  };

  return (
    <section id="contact" className="py-24 md:py-32 bg-background relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-primary/5" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-xs font-medium tracking-[0.3em] text-primary uppercase mb-4 block">Ready to Try?</span>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl text-foreground mb-6">
              Experience<br />The <span className="text-primary">Bold</span>
            </h2>
            <p className="text-muted-foreground mb-8 leading-relaxed text-lg max-w-md">
              Join thousands who have made {currentVariant.name} {currentVariant.subtitle} their go-to refreshment. Taste the difference that bold flavor and quality ingredients make.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <button
                onClick={handleAddToCart}
                className="px-8 py-4 rounded-full bg-primary text-primary-foreground font-medium tracking-wider uppercase transition-all duration-300 hover:shadow-glow hover:scale-105"
              >
                Add to Cart — ₪{currentVariant.price}
              </button>
              <button className="px-8 py-4 rounded-full border border-foreground/30 text-foreground font-medium tracking-wider uppercase transition-all duration-300 hover:border-primary hover:text-primary">
                Find a Store
              </button>
            </div>

            <p className="text-sm text-muted-foreground">
              Free shipping on orders above ₪120. Minimum order ₪80.
            </p>
          </div>

          <div className="relative">
            <div className="relative aspect-square max-w-md mx-auto">
              <img
                src={currentVariant.productImage}
                alt={`${currentVariant.name} ${currentVariant.subtitle}`}
                className="w-full h-full object-contain animate-float drop-shadow-2xl"
              />
              <div className="absolute inset-0 bg-primary/30 blur-3xl -z-10 scale-75" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
